import React from 'react'
import { Select } from 'antd'
import moment from 'moment'
import { getRangesWeeks } from '../services/Utils'

const { Option } = Select

const WeekPicker2 = ({ onChange, year = null, value = null }) => {
    const [options, setOptions] = React.useState(getRangesWeeks(year))
    const [currentValue, setCurrentValue] = React.useState(0)

    React.useEffect(() => {
        setCurrentValue(value)
    }, [value])

    React.useEffect(() => {
        setOptions(getRangesWeeks(year))
    }, [year])

    return (
        <>
            <Select
                style={{ width: '100%' }}
                value={currentValue}
                onChange={value => {
                    const indexFind = options.findIndex(f => f.value === value)
                    onChange && onChange(value, options[indexFind])
                }}
            >
                {options.map((item, index) => (
                    <Option key={index} value={item.value}>
                        {item.label}
                    </Option>
                ))}
            </Select>
        </>
    )
}

export default WeekPicker2
